import Vue from 'vue/dist/vue.esm.js';
import {formatPrice} from '../utility/formatPrice'

Vue.component('search-autocomplete', {
    template: `#search-autocomplete`,
    delimiters: ['[[', ']]'],
    props: {
        locale: {
            required: true,
            type: String,
        },
        currency: {
            required: true,
            type: String,
        },
        searchUrl: {
            required: true,
            type: String,
        },
        searchPageUrl: {
            required: true,
            type: String,
        },
        exchangeRate: {
            required: true,
            type: String,
        },
        exchangeRateMode: {
            required: true,
            type: String,
        },
        convertMode: {
            required: true,
            type: String,
        },
        showEurFirst: {
            required: false,
            type: String,
            default: '0'
        },
        searchConversionUrl: {
            required: false,
            type: String,
            default: ''
        }
    },

    mounted() {

    },

    data() {
        return {
            results: [],
            term: '',
            timeout: 0,
            logViewsTimeout: 0,
            isLoading: false,
            isDropdownVisible: false,
        }
    },

    methods: {
        formatDualPrice(price) {
            return formatPrice(price, this.exchangeRate, this.exchangeRateMode, this.convertMode, true, this.showEurFirst);
        },
        documentOnClick() {
            this.hide();
        },
        show() {
            this.isDropdownVisible = true;
            document.addEventListener("click", this.documentOnClick);
        },
        hide() {
            this.isDropdownVisible = false;
            document.removeEventListener("click", this.documentOnClick);
        },
        inputOnClick(e) {
            e.stopPropagation();
        },
        containerOnClick(e) {
            e.stopPropagation();
        },
        onFocus() {
            this.show();
        },

        onKeyUp() {

            if (this.term == '' || this.term != event.target.value) {
                this.term = event.target.value;
            }

            if (!this.isDropdownVisible) {
                this.show();
            }

            this.isLoading = true;
            clearTimeout(this.timeout);
            clearTimeout(this.logViewsTimeout);
            this.timeout = setTimeout(this.search, 600);
        },

        search() {

            this.results = [];
            let _self = this;

            if (this.term === '') {
                return;
            }
            $.ajax({
                data: {term: _self.term},
                url: _self.searchUrl,
                method: 'GET',
                success: function (result) {
                    _self.isLoading = false;
                    _self.results = result;
                    clearTimeout(_self.logViewsTimeout);
                    _self.logViewsTimeout = setTimeout(function () {
                        _self.logItemViewsIfApplicable(result);
                    }, 800);
                },
            });
        },


        formattedPrice(price) {
            return new Intl.NumberFormat(this.locale, {style: 'currency', currency: this.currency}).format(price);
        },

        logItemViewsIfApplicable(result) {
            const products = result?.products;
            const searchTerm = (this.term || '').trim().toLowerCase();
            if (!searchTerm || !products?.length || !this.searchConversionUrl) return;

            const productIds = products.map(p => p.id).filter(Boolean);
            if (productIds.length === 0) return;

            const payload = JSON.stringify({
                search_term: searchTerm,
                conversion_type: 'item_view',
                product_ids: productIds
            });
            const url = this.searchConversionUrl;
            if (navigator.sendBeacon) {
                const blob = new Blob([payload], { type: 'application/json' });
                navigator.sendBeacon(url, blob);
            } else {
                fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                    body: payload
                }).catch(() => {});
            }
        },

        onProductClick(event, product) {
            const searchTerm = (this.term || '').trim().toLowerCase();
            const productId = product.id;

            if (searchTerm && productId && this.searchConversionUrl) {
                sessionStorage.setItem(`item_list_id_${productId}`, `search-${searchTerm}`);
                const payload = JSON.stringify({
                    search_term: searchTerm,
                    conversion_type: 'product_click',
                    product_id: productId
                });
                if (navigator.sendBeacon) {
                    const blob = new Blob([payload], { type: 'application/json' });
                    navigator.sendBeacon(this.searchConversionUrl, blob);
                } else {
                    fetch(this.searchConversionUrl, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                        body: payload
                    }).catch(() => {});
                }
            }

            window.location.href = product.url;
        }

    },

    computed: {
        fullSearchUrl() {
            return this.searchPageUrl + '?term=' + this.term;
        }
    }
});